import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { CommonService } from 'src/app/shared/service/common.service';
import { logout } from 'src/app/store/user/user.actions';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class LogoutComponent implements OnInit {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly commonService: CommonService,
    private readonly store: Store,
    private readonly utils: UtilService
  ) {}

  ngOnInit() {
    if (this.commonService.getlocalStorageItem('token')) {
      this.utils.logoutApi().subscribe((ele) => {
        this.clearItems();
        this.authenticationService.setAuthSubject(null);
      });
    } else {
      this.clearItems();
    }
  }

  clearItems() {
    this.commonService.clearLocalStorageItems();
    sessionStorage.clear();
    this.store.dispatch(logout());
    this.utils.redirectToLogin();
  }
}
